import React, { FC, useMemo, useRef } from 'react';

import { useModal } from 'context/ModalProvider/useModal';
import { DataGrid } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { CreateTrailerModal } from './modals/CreateTrailerModal/CreateTrailerModal';
import { EditTrailerModal } from './modals/EditTrailerModal/EditTrailerModal';
import { TrailerListPage } from './pages/TrailerListPage';

export const TrailerScreen: FC = () => {
  const { showModal } = useModal();
  const dataGridRef = useRef<DataGrid | null>(null);

  const trailerDataStore: any = useMemo(() => {
    return $createDataSource('/v1/Trailer', 'id');
  }, []);

  const handleRefresh = () => dataGridRef.current?.instance.refresh();

  const handleCreate = () => {
    showModal(<CreateTrailerModal onRefresh={handleRefresh} />);
  };

  const handleEdit = (id: number) => {
    showModal(<EditTrailerModal id={id} onRefresh={handleRefresh} />);
  };

  return (
    <TrailerListPage
      dataSource={trailerDataStore}
      onCreate={handleCreate}
      onEdit={handleEdit}
      onDeleted={handleRefresh}
      ref={dataGridRef}
    />
  );
};
